import React from 'react';
import AppOrder from './AppOrder';
import Order from './Order';
import EcodeOrder from './EcodeOrder';
import OrderWfE8 from './OrderWfE8';
import HeaderOrder from './HeaderOrder';
// import "../../mock/ecodeData";

class App extends React.Component {
  render() {
    const id = this.props.location.query.id;
    if (id === 'app') return (<HeaderOrder {...this.props}><AppOrder {...this.props} /></HeaderOrder>);
    if (id === 'ecode') return (<HeaderOrder {...this.props}><EcodeOrder {...this.props} /></HeaderOrder>);
    return (<OrderWfE8 {...this.props} />);
  }
}
export default App


// WEBPACK FOOTER //
// ./src/components/order/index.js